/*
 * Created by baiYu at 2021-06-02
 * FileName: CreditCard.tsx
 * 信息技术服务合同 - 信用卡分期
 */

import { setTitle } from "@src/util";
import CustomScroll from "@src/component/customScroll";
export default function () {
  setTitle("信息技术服务合同");
  return (
    <div className="page bottomFit">
      <CustomScroll>
        <div className="itInformation">
          <h2>甲方：北京弘芸信息技术有限公司</h2>
          <h3>法定代表人：李直</h3>
          <h4>住址：北京市朝阳区望京街9号商业楼3层313号377室</h4>
          <h4>乙方： 申请人 </h4>
          <ul>
            <li>
              甲乙双方经友好协商，就甲方为乙方提供信用卡申请资料接收和传递信息技术服务及代收代付指定商品价款服务，达成本协议，以备共同遵守。
            </li>
          </ul>
          <p>一、信用卡分期资料接收和传递的信息技术服务</p>
          <ul>
            <li>
              1、乙方拟向指定银行申请办理信用卡分期业务。申请分期的总金额，以乙方提交申请及银行最终审核批准的金额为准。
            </li>
            <li>
              2、甲方根据指定银行委托及本合同约定，利用自有或合作的互联网服务平台接收乙方提交的信用卡分期申办资料，并按照指定银行规定的程序和时限向其报送。
            </li>
            <li>
              3、甲方仅负责接收乙方提交的申办资料，并依约向指定银行报送。乙方应当保证提交的申请资料真实准确，并在指定银行要求的有效时限内，如乙方利用虚假资料骗取信用卡分期的，乙方应承担违约、违法责任，情节严重的，银行和甲方有权向公安机关报案追究乙方的刑事责任。
            </li>
            <li>
              4、甲方不对指定银行的审核时限、最终审核结果向乙方作出任何的承诺或保证，无论指定银行最终是否通过乙方的申请、最终分期额度、还款时限等，甲方均不承担任何责任。
            </li>
            <li>
              5、如指定银行最终通过乙方的信用卡分期申请，乙方与指定银行之间的权利义务，由乙方与指定银行签署的信用卡分期协议（或相关协议）约定。乙方与指定银行之间的全部债权债务纠纷，均由乙方和指定银行自行负责处理，甲方不承担任何责任。但甲方有权利根据指定银行的要求或司法、行政机关的命令，向其提供乙方提交资料的详细内容、本合同内容或对甲方负责的接收和传递环节进行口头或书面说明。
            </li>
            <li>
              6、如因乙方的过失、违约违法行为，导致甲方受到来自指定银行或任何第三方，及行政监管、司法部门追究的，乙方应当根据甲方的实际损失承担赔偿责任。
            </li>
          </ul>
          <p>二、指定商品价款的代收及代付</p>
          <ul>
            <li>
              1、如乙方成功申请指定银行信用卡分期业务，乙方应在【3】个工作日内使用该信用卡将卡内全部分期款项一次性划入甲方指定账户。
            </li>
            <li>2、甲方的收款账户为：</li>
            <li>户名：【北京弘芸信息技术有限公司】</li>
            <li>开户银行：【交通银行北京望京支行】</li>
            <li>账号：【110060906013000823587】</li>
            <li>
              3、甲方收到乙方使用信用卡划卡支付的款项，总金额应当等于乙方申请的分期总金额。甲方按照本合同约定，在收到放款后2个工作日内向乙方指定的出卖方支付指定商品价款。
            </li>
            <li>
              4、乙方指定的出卖方、商品型号、单价及甲方应代付金额，已乙方提交的分期总金额明细为准。
            </li>
            <li>
              5、甲方在完成付款后，乙方自行向出卖方提取指定商品，并依约向指定银行履行还款义务。
            </li>
            <li>
              6、甲方仅作为信息技术服务提供方，为乙方提供收集传递资料和集中收付款服务，并不代表甲方与乙方之间存在任何的借贷关系，也不对乙方与包括商品出卖方在内的任何第三方承担担保、连带责任。
            </li>
            <li>
              7、如乙方申请通过的信用卡分期金额不足以支付乙方指定出卖方指定商品的价款时，乙方应当自行向出卖方补足差额。甲方在收到足额的款项或确认乙方已补足商品差额之前，有权拒绝向出卖方支付商品价款。如乙方在接到甲方补款通知后【3】个工作日内仍未补足的，甲方有权终止支付，将已收到的分期款项原路返还给付款方。
            </li>
          </ul>
          <p>三、通知</p>
          <ul>
            <li>
              1、乙方在申请办理信用卡分期业务时应向甲方提交联系地址及联系方式。
            </li>
            <li>
              2、乙方发生地址变更、名称变更、法定代表人变更,企业分立、合并、重组、关闭、停产、被兼并、转产、申请破产或发生了影响本合同的重大债权、债务,或发生诉讼、仲裁，或经营内容有重大改变等情形时,应在前述情形发生之日起10日内书面通知出租人。
            </li>
            <li>
              3、根据本合同发出的或与本合同有关的所有通知或其它通讯应以书面形式发出,如无其它规定,可以采用信函或传真方式。任何通知将被视为于下述时间送达:
            </li>
            <li>4、（1）采用信函方式发出的,于专人递交或实际收到时送达；</li>
            <li>
              5、（2）采用电子邮件方式发出的,于电子邮件发送成功时完成送达。
            </li>
            <li>
              6、乙方同意并确认所提交地址作为本合同项下争议所涉诉讼/仲裁文书的送达地址。上述诉讼/仲裁文书包括不限于传票、开庭通知书、判决书、裁定书、调解书、限期履行通知书等；上述送达地址适用于一审、二审、再审、执行等各个执行阶段,相关诉讼/仲裁文书按上述地址进行送达,因无人签收、拒收等原因导致被退回的,退回之日即视为送达之日。地址如有变更，乙方应及时书面通知甲方，否则按本条约定的地址进行的送达仍然有效，乙方应自行承担由此产生的法律后果。
            </li>
            <p>四、免责条款</p>
            <li>
              1、甲方仅为乙方提供信息技术及约定的代收代付商品价款服务，对于银行或其他金融机构的行为不承担任何的保证及连带责任。
            </li>
            <li>
              2、因生产商或出卖方对商品进行的改款、升级、停产、调整价格等行为，甲方无法预计、无法避免的因素，造成乙方最终获得的商品与本合同签订时相应商品配置和价格不符的，甲方不承担责任。
            </li>
            <li>
              3、因为通信提供商或乙方自己的通信终端的原因，造成乙方无法使用信息技术服务的，甲方不承担责任。
            </li>
            <li>
              4、因为硬件故障、硬件设备托管机构、通信线路提供商、黑客入侵等因素造成乙方在甲方的资料数据灭失的，甲方不承担责任。
            </li>
            <p>五、违约责任</p>
            <li>
              {" "}
              1、乙方应当根据银行和金融机构的要求，提供真实且在规定有效期内的个人信息资料，如乙方提供虚假、无效资料或未能在期限内提供的，甲方有权随时终止本合同。乙方如因此受到银行、金融机构、出卖方及其他任何第三方，或行政、司法机构追究的，由乙方自行承担全部责任，因此导致甲方被第三方追究责任的，乙方应当承担赔偿责任。
            </li>
            <li>
              2、乙方获取指定银行批准的信用卡分期服务后，应在本合同约定期限内将商品价款划入甲方指定账户。如乙方逾期未履行付款义务的，甲方有权上报指定银行处理。如因此造成乙方持有的信用卡冻结或终止服务，甲方不承担责任。
            </li>
            <li>
              {" "}
              3、甲方代收的商品价款，仅作为支付本合同指定出卖方、指定商品价款，乙方不得要求甲方将该款项支付给包括乙方本人在内的任何其他收款方。如乙方违反本条，甲方有权拒绝支付，并将收到的款项原路返回付款方。乙方如因此违反与指定银行及金融机构合同约定，产生的违约责任由乙方自行承担。
            </li>
            <p>六、法律管辖</p>
            <li>1、本合同的订立、执行和解释及争议的解决均应适用中国法律。</li>
            <li>
              2、如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向甲方所在地的人民法院提起诉讼。
            </li>
            <li>
              <br />
            </li>
            <li>
              <br />
            </li>
            <li>甲方：北京弘芸信息技术有限公司 </li>
            <li>乙方：申请人</li>
          </ul>
          <br />
        </div>
      </CustomScroll>
    </div>
  );
}
